export const PPT_ACCOUNT_WATCH_LIST_ITEM_TYPE = 'ppt';